import React from 'react';
import { Input } from 'web-ui-components/lib/atoms/forms';
import { Field as FormField, FieldBody, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import PropTypes from '../../../types';
import { isValidGlobalBehaviour } from '../../../utils/validation';

const required = value => (isValidGlobalBehaviour(value, 'accountName') ? undefined : 'Required');

const OldAccountHolder = ({ maxAccountNameLength }) => (
  <Content>
    {({ oldAccountHolderLabel = '', accountHolderNameError = '', oldAccountHolderDescription }) => (
      <Field name="name" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <FormField>
            <FieldHeader
              name="name"
              hasError={touched && !!error}
              title={oldAccountHolderLabel}
              validationMessage={accountHolderNameError}
              description={oldAccountHolderDescription}
            />
            <FieldBody hasError={touched && !!error}>
              <Field name="name" component="input" validate={required}>
                {({ input }) => (
                  <Input name="name" maxLength={maxAccountNameLength} type="text" {...input} />
                )}
              </Field>
            </FieldBody>
          </FormField>
        )}
      </Field>
    )}
  </Content>
);

OldAccountHolder.propTypes = {
  maxAccountNameLength: PropTypes.number
};

OldAccountHolder.defaultProps = {
  maxAccountNameLength: 18
};

export default OldAccountHolder;
